import React from 'react';
import PropTypes from 'prop-types';
import AccordionSection from '../AccordionSection';
import CopyButton from '../CopyButton';

/**
 * Coach response display component
 */
const CoachResponse = ({ coachResponse, expanded, onToggle }) => {
  const copyText = `=== COACH RESPONSE ===\n\n${coachResponse || 'No response available'}`;

  return (
    <div className="relative">
      <AccordionSection
        title="Coach Response"
        defaultExpanded={true}
        colorTheme="green"
        expanded={expanded}
        onToggle={onToggle}
      >
        <div className="text-sm text-green-100 whitespace-pre-wrap">
          {coachResponse || 'No response available'}
        </div>
      </AccordionSection>
      <CopyButton
        onCopy={copyText}
        ariaLabel="Copy coach response"
        title="Copy coach response"
        colorTheme="green"
      />
    </div>
  );
};

CoachResponse.propTypes = {
  coachResponse: PropTypes.string,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default React.memo(CoachResponse);

